import { render, staticRenderFns } from "./MemoBot.vue?vue&type=template&id=163050eb&scoped=true&"
import script from "./MemoBot.vue?vue&type=script&lang=js&"
export * from "./MemoBot.vue?vue&type=script&lang=js&"
import style0 from "./MemoBot.vue?vue&type=style&index=0&id=163050eb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163050eb",
  null
  
)

export default component.exports